import type { EnhancedCategoryTrend } from "../types/index.ts";

interface CategoryBarChartProps {
  categories: EnhancedCategoryTrend[];
}

export function CategoryBarChart({ categories }: CategoryBarChartProps) {
  if (categories.length === 0) {
    return <div className="td-chart-empty">No category data</div>;
  }

  const maxScore = Math.max(...categories.map((c) => c.avgScore), 1);

  return (
    <div className="td-cat-chart">
      {categories.map((cat) => {
        const pct = (cat.avgScore / maxScore) * 100;
        return (
          <div key={cat.slug} className="td-cat-chart-row">
            <span className="td-cat-chart-label">{cat.category}</span>
            <div className="td-cat-chart-track">
              <div
                className="td-cat-chart-fill"
                style={{ width: `${pct}%`, backgroundColor: cat.color }}
              />
            </div>
            <span className="td-cat-chart-value">{cat.avgScore.toFixed(1)}</span>
          </div>
        );
      })}
    </div>
  );
}

interface CategoryCardsProps {
  categories: EnhancedCategoryTrend[];
  period: number;
  onClickHandle?: (twitterHandle: string) => void;
}

export function CategoryCards({ categories, period, onClickHandle }: CategoryCardsProps) {
  if (categories.length === 0) {
    return <div className="td-chart-empty">No category data</div>;
  }

  function HandleLink({
    handle,
    prefix,
    className,
  }: {
    handle: string;
    prefix: string;
    className: string;
  }) {
    if (onClickHandle) {
      return (
        <button
          type="button"
          className={`td-cat-card-mover td-cat-card-mover--clickable ${className}`}
          onClick={() => onClickHandle(handle)}
        >
          {prefix}: @{handle}
        </button>
      );
    }
    return (
      <span className={`td-cat-card-mover ${className}`}>
        {prefix}: @{handle}
      </span>
    );
  }

  return (
    <div className="td-cat-cards">
      {categories.map((cat) => (
        <div key={cat.slug} className="td-cat-card" style={{ borderTopColor: cat.color }}>
          <div className="td-cat-card-header">
            <span className="td-cat-card-name">{cat.category}</span>
            <span className="td-cat-card-count">{cat.projectCount} projects</span>
          </div>
          <div className="td-cat-card-stats">
            <div className="td-cat-card-stat">
              <span className="td-cat-card-stat-value">{cat.avgScore.toFixed(1)}</span>
              <span className="td-cat-card-stat-label">Avg Score</span>
            </div>
            <div className="td-cat-card-stat">
              <span
                className={`td-cat-card-stat-value ${cat.avgDelta > 0 ? "positive" : cat.avgDelta < 0 ? "negative" : ""}`}
              >
                {cat.avgDelta > 0 ? "+" : ""}
                {cat.avgDelta.toFixed(1)}
              </span>
              <span className="td-cat-card-stat-label">{period}d Delta</span>
            </div>
          </div>
          <div className="td-cat-card-movers">
            {cat.topGainer && (
              <HandleLink handle={cat.topGainer} prefix="Top" className="positive" />
            )}
            {cat.topLoser && <HandleLink handle={cat.topLoser} prefix="Bot" className="negative" />}
          </div>
        </div>
      ))}
    </div>
  );
}
